export * from './document-block.variants.defaults';
